import { createContext } from 'react';

/**
 * QuestionnaireIdPrefixContext — a per-Questionnaire-instance prefix for DOM ids,
 * radio `name`s, and `htmlFor` associations.
 *
 * Two full Questionnaire trees can be mounted in the SAME document at once (the form
 * editor's editable Preview tab + the read-only PDF-preview overlay portalled to
 * <body>). Without scoping, both emit identical DOM ids and radio group `name`s, which
 * the browser treats globally: a label's `htmlFor` resolves to the FIRST matching id
 * (the background instance), same-`name` radios merge into one native group (so opening
 * the overlay unchecks the Preview tab's radios), and `getElementById(section.id)` for
 * scroll-spy targets the wrong instance. The Questionnaire seeds this context with a
 * stable `useId()` value and threads the same prefix to its index-owned consumers
 * (section ids, scroll hook, mobile nav).
 *
 * Default '' means any leaf rendered WITHOUT a provider (single-instance pages, or the
 * uploaders/selectors reused outside the questionnaire tree) emits byte-identical,
 * un-prefixed ids — so this change is inert everywhere except the co-mounted case.
 */
export const QuestionnaireIdPrefixContext = createContext('');
